import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconDelete = createIcon({
  displayName: 'IconDelete',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M11 2H13V4H21V6H3V4H11V2ZM19 22H5V8H7V20H17V8H19V22ZM13 8H15V18H13V8ZM11 8H9V18H11V8Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
